import confirmSelector from './confirm_selector.js'

export default {
	confirmSelector,
}
